import type React from "react";
import { CssIcon } from "styles/helpers/layout";
import { type StatusTagVariant, StyledStatusTag } from "./StatusTag.styled";

export interface StatusTagProps {
  className?: string;
  label: string;
  icon?: string;
  dataCy?: string;
  variant?: StatusTagVariant;
  [key: `data-${string}`]: string;
}

export const StatusTag: React.FC<StatusTagProps> = ({
  className,
  label,
  icon,
  dataCy,
  variant = "default",
  ...otherProps
}) => {
  return (
    <StyledStatusTag $variant={variant} className={className} data-cy={dataCy} {...otherProps}>
      {icon && <CssIcon iconName={icon} />}
      {label}
    </StyledStatusTag>
  );
};
